module.exports = __webpack_public_path__ + "img/gryphon_rock_small.49360c98.png";